import { Route, Routes } from 'react-router-dom';
import ForgotPassword from '../../components/authentication/ForgotPassword';
import NewPassword from '../../components/authentication/NewPassword';
import ResetPassword from '../../components/authentication/ResetPassword';
import SignIn from '../../components/authentication/signIn/SignIn';
import SupervisorSignUp from '../../components/authentication/ExternalSupervisor/SupervisorSignUp';
import { IRoute } from '../interfaces/IRoute';
import { sharedPaths, unauthenticatedPaths } from '../constants/route-paths';
import ChangePassword from '../../components/authentication/ChangePassword';
import LoginWithEmailAndPassword from '../../components/authentication/signIn/LoginWithEmailAndPassword';

export const UnauthenticatedRoutes = () => {
    const routes: IRoute[] = [
        {
            path: unauthenticatedPaths.base,
            element: <SignIn />,
        },
        {
            path: unauthenticatedPaths.signIn,
            element: <SignIn />,
        },
        {
            path: unauthenticatedPaths.newPassword,
            element: <NewPassword />,
        },
        {
            path: unauthenticatedPaths.resetPassword,
            element: <ResetPassword />,
        },
        {
            path: unauthenticatedPaths.forgotPassword,
            element: <ForgotPassword />,
        },
        {
            path: unauthenticatedPaths.loginWithEmailAndPassword,
            element: <LoginWithEmailAndPassword />,
        },
        {
            path: sharedPaths.forcePasswordChange,
            element: <ChangePassword />,
        },
        {
            path: unauthenticatedPaths.invitation,
            element: <SupervisorSignUp />,
        },
    ];

    return (
        <Routes>
            {routes.map((value, index) => (
                <Route
                    key={index}
                    path={value.path}
                    element={value.element}
                ></Route>
            ))}
        </Routes>
    );
};
